var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('van-nav-bar',{attrs:{"title":"审批系统"}}),_c('img',{staticClass:"errorImg",attrs:{"src":require("assets/image/error.png"),"alt":""}}),_c('p',{staticClass:"error-tips"},[_vm._v("提现失败")]),_c('p',{staticClass:"error-text"},[_vm._v("账户异常请您更换其他账户完成放款")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }